import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import type { TradeInComponent } from '@makemydeal/dr-dash-types';

export interface TradeInItemWithIndex {
    tradeIn: any;
    tradeInComponent?: TradeInComponent;
    originalIndex: number;
    isDeleted?: boolean;
    isExpanded?: boolean;
}

export const useTrades = () => {
    // Get all trade-ins to show deleted ones (for restore functionality)
    const allTradeIns = useSelector(tradeInsSelectors.getAllTradeIns);

    const tradeIns = useMemo((): TradeInItemWithIndex[] => {
        // Filter by shouldIncludeTradeIn but preserve deleted trades and original indexes
        return allTradeIns
            .map((item, index) => ({ ...item, originalIndex: index }))
            .filter((item) => item.tradeIn.shouldIncludeTradeIn);
    }, [allTradeIns]);

    return {
        tradeIns
    };
};
